const PRICING_PACKAGING_EVENTS = {
  pricingPackaging: {
    featuresView: {
      chatWithSupportClicked: true,
      planClicked: true,
      planDurationMonthlySelected: true,
      planDurationYearlySelected: true,
      seeAllFeaturesOpened: true,
      seeEachCardFeaturesOpened: true,
      visited: true,
    },
    pricingView: {
      chatWithSupportClicked: true,
      planClicked: true,
      planDurationMonthlySelected: true,
      planDurationYearlySelected: true,
      seeAllFeaturesOpened: true,
      seeEachCardFeaturesOpened: true,
      visited: true,
    },
  },
};

export default PRICING_PACKAGING_EVENTS;
